import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Bank info response body */
export interface BankFindInterface {
  id: number;
  name: string;
  city: string;
  address: string;
  bik: string;
  ks: string;
  index: string;
}

/** Bank info response body - DTO schema */
export const BankFindDto = SerdeDtoClass.create<BankFindInterface>(CatalogDtosKeysEnum.BANK_FIND_DTO, {
  id: {
    label: 'Номер банка в ФРМ',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Название банка',
    serializer: yup.string(),
  },
  city: {
    label: 'Город',
    serializer: yup.string(),
  },
  address: {
    label: 'Адрес',
    serializer: yup.string(),
  },
  bik: {
    sortable: true,
    label: 'БИК',
    serializer: yup.string(),
  },
  ks: {
    label: 'Корреспондентский счет',
    serializer: yup.string(),
  },
  index: {
    label: 'Почтовый индекс',
    serializer: yup.string(),
  },
});
